module.exports = __webpack_public_path__ + "img/img-7.933e8e8b.png";